export default __webpack_public_path__ + "static/media/landing.7f7d93c2.png";